import React from "react";
import { Flex, FlexboxProps } from "@chakra-ui/react";
import { FiHelpCircle } from "react-icons/fi";

import { CurrentUserDropdown } from "components";
import NavLink from "components/PrimaryNav/NavLink";

const Header: React.FC<FlexboxProps> = ({ ...props }: FlexboxProps) => {
  return (
    <Flex
      as="nav"
      alignItems="center"
      justifyContent="flex-end"
      bg="gray.800"
      px={[4, 12]}
      w="100%"
      h="72px"
      fontWeight="300"
      fontSize="xl"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
    >
      <NavLink
        justifySelf={"end"}
        label="Help"
        icon={FiHelpCircle}
        to="/help"
        width="fit-content"
        hideLabel={true}
        p={2}
        mr={7}
        rounded="full"
      />
      <CurrentUserDropdown />
    </Flex>
  );
};

export default Header;
